// Comune per abbonati scelto senza abbonamento attivo.

import React from "react";
import { Button, Dialog } from "./ui";
import SubscribeButton from "./SubscribeButton";
import { OMNI_LOGIN_URL } from "../lib/config";

export default function LockedDialog({ city, auth, onClose }) {
  let text;
  let action;
  if (auth.status === "offline") {
    text = "Non riesco a verificare l'abbonamento: OmniSurv non risponde. Riprova tra qualche istante.";
    action = <Button icon="check" onClick={auth.refresh}>Riprova</Button>;
  } else if (auth.status === "free") {
    text = `${city.name} è incluso nell'abbonamento SurvMaps e nell'abbonamento OmniSurv completo. `
      + `Il tuo account${auth.email ? ` (${auth.email})` : ""} non ne ha uno attivo.`;
    action = <SubscribeButton auth={auth} />;
  } else {
    text = `${city.name} è per gli abbonati SurvMaps o OmniSurv. Accedi (o registrati) con il tuo account OmniSurv `
      + "in un'altra scheda, poi torna qui: SurvMaps riconosce l'accesso da solo.";
    action = (
      <a className="sm-btn sm-btn--primary" href={OMNI_LOGIN_URL} target="_blank" rel="noopener noreferrer">
        Accedi o registrati
      </a>
    );
  }
  return (
    <Dialog
      title={`${city.name} · abbonati`}
      onClose={onClose}
      footer={<>{action}<Button variant="ghost" onClick={onClose}>Chiudi</Button></>}
    >
      <p className="sm-panel-text" style={{ fontSize: "var(--fs-sm)" }}>{text}</p>
    </Dialog>
  );
}
